import { Breakpoint, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Close } from '@mui/icons-material'
import { v4 as UUID } from 'uuid'

const useStyles = makeStyles()(_ => ({
    icon: {
        position: 'absolute',
        right: 8,
        top: 8,
        color: '#00304a',
    },
}))

interface IGenericDialogProps {
    title: string
    open: boolean
    onClose: () => void
    width?: string | number
    maxWidth?: false | Breakpoint
    fullWidth?: boolean
    disableAutoClose?: boolean
    actions?: React.ReactNode[]
    removedCloseButton?: boolean
    container?: HTMLElement
}
export const GenericDialog: React.FC<IGenericDialogProps> = ({
    title,
    open,
    onClose,
    maxWidth,
    disableAutoClose,
    actions,
    fullWidth = true,
    removedCloseButton,
    children,
    container = null
}) => {
    const { t } = useTranslation()
    return (
        <>
            <Dialog
                open={open}
                onClose={(e, reason) => {
                    if (disableAutoClose && reason === 'backdropClick') return
                    onClose()
                }}
                fullWidth={fullWidth}
                disableEscapeKeyDown
                maxWidth={maxWidth}
                container={container}
                onBackdropClick={_ => { }}
            >
                <CustomDialogTitle onClose={onClose}>{title}</CustomDialogTitle>
                <DialogContent >{children}</DialogContent>
                {
                    (!removedCloseButton || actions) &&
                    <DialogActions >
                        {[
                            !removedCloseButton ? (
                                <Button key={UUID()} onClick={onClose} variant="text">
                                    {t('cancel', { ns: 'common' })}
                                </Button>
                            ) : (
                                <></>
                            ),
                            ...(actions ? actions : []),
                        ]}
                    </DialogActions>
                }
            </Dialog>
        </>
    )
}

export interface DialogTitleProps {
    children?: React.ReactNode
    onClose?: () => void
}

export const CustomDialogTitle: React.FC<DialogTitleProps> = props => {
    const { children, onClose, ...other } = props
    const { classes } = useStyles()

    return (
        <DialogTitle className="border-b padding-8" {...other}>
            <span >{children}</span>
            {onClose ? (
                <IconButton aria-label="close" onClick={onClose} className={classes.icon}>
                    <Close />
                </IconButton>
            ) : null}
        </DialogTitle>
    )
}
